import React from 'react';
import MarkdownWrapper from '../MarkdownWrapper';
import styles from './TldrSection.module.less';

type TldrSectionProps = {
  tldr?: string;
};
const TldrSection: React.FC<TldrSectionProps> = ({ tldr }) => {
  if (!tldr) {
    return null;
  }
  return (
    <div className={styles.container}>
      <div className={styles.maxWidthContainer}>
        <MarkdownWrapper source={tldr} styleOverride={styles.markdownStyleOverride} />
      </div>
    </div>
  );
};

export default TldrSection;
